<template>
  <ol
    :class="{
      '!list-[lower-alpha]': isTerms
    }"
  >
    <slot />
  </ol>
</template>
<script setup lang="ts">
const route = useRoute()

const isTerms =
  route.fullPath.includes('/terms') || route.fullPath.includes('/privacy')
</script>
